import { api } from '@marketplace-web/core-api/core-api-client-util'

import { CountriesResp } from '../types/countries-resp'

export const getCountries = (locale?: string) =>
  api.get<CountriesResp>('/countries', {
    params: locale ? { locale } : {},
  })
